import request from '@/utils/request'

export function getCouponInfo(data) {
    return request({
        url: '/backend/coupon/getCouponInfo',
        method: 'post',
        data: data
    })
}

//更改优惠卷适用群体
export function saveCouponGroup(data) {
    return request({
        url: '/backend/coupon/saveCouponGroup',
        method: 'post',
        data: data
    })
}

//适应人群商品列表（用户、课程、商品等）
export function couponProductList(data) {
    return request({
        url: '/backend/coupon/couponProductList',
        method: 'post',
        data: data
    })
}

//筛选商品列表
export function screenProductList(data) {
    return request({
        url: '/backend/coupon/screenProductList',
        method: 'post',
        data: data
    })
}

//保存筛选后商品信息
export function saveProductInfo(data) {
    return request({
        url: '/backend/coupon/saveProductInfo',
        method: 'post',
        data: data
    })
}

//适应人群商品删除
export function couponProductDelete(data) {
    return request({
        url: '/backend/coupon/couponProductDelete',
        method: 'post',
        data: data
    })
}

//保存分享扩展信息
export function saveShareExtend(data) {
    return request({
        url: '/backend/coupon/saveShareExtend',
        method: 'post',
        data: data
    })
}

//优惠券列表
export function getCouponList(data) {
    return request({
        url: '/backend/coupon/getCouponList',
        method: 'post',
        data: data
    })
}
//创建、编辑接口
export function createUpdate(data) {
    return request({
        url: ' /backend/live/blessingBag/createUpdate',
        method: 'post',
        data: data
    })
}
//获取福袋详情接口
export function getInfo(data) {
    return request({
        url: ' /backend/live/blessingBag/getInfo',
        method: 'post',
        data: data
    })
}
//获取寄语列表接口
export function getcalendarlist(data) {
    return request({
        url: ' /backend/calendar/message/list',
        method: 'post',
        data: data
    })
}
//创建寄语接口
export function setcalendarinfo(data) {
    return request({
        url: ' /backend/calendar/message/create',
        method: 'post',
        data: data
    })
}
///backend/calendar/message/info
//寄语详情接口
export function calendarinfo(data) {
    return request({
        url: ' /backend/calendar/message/info',
        method: 'post',
        data: data
    })
}
//更新寄语接口
export function calendarupdate(data) {
    return request({
        url: ' /backend/calendar/message/update',
        method: 'post',
        data: data
    })
}

export function getExchangeCoupon(data) {
    return request({
        url: '/backend/coupon/getExchangeCoupon',
        method: 'post',
        data: data
    })
}
export function setVerCodeState(data) {
    return request({
        url: '/backend/coupon/setVerCodeState',
        method: 'post',
        data: data
    })
}
// /backend/employee/performance/create
export function createperformance(data) { // 创建绩效接口
    return request({
        url: '/backend/employee/performance/create',
        method: 'post',
        data: data
    })
}
// /backend/employee/performance/getAccountRole
export function getAccountRole(data) { // 获取后台用户角色
    return request({
        url: '/backend/employee/performance/getAccountRole',
        method: 'post',
        data: data
    })
}

///backend/employee/performance/getDepartmentListMenu
export function getDepartmentListMenu(data) { // 获取左侧菜单栏
    return request({
        url: '/backend/employee/performance/getDepartmentListMenu',
        method: 'post',
        data: data
    })
}

// /backend/employee/performance/getPerformanceList
export function getPerformanceList(data) { // 绩效列表
    return request({
        url: '/backend/employee/performance/getPerformanceList',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/list
export function getappraisalList(data) { // 测试活动列表页
    return request({
        url: '/backend/activity/test/list',
        method: 'post',
        data: data
    })
} 
// /backend/activity/test/create 
export function getappraisacreate(data) { // 创建测试活动信息
    return request({
        url: '/backend/activity/test/create',
        method: 'post',
        data: data
    })
}
//backend/activity/test/info
export function getappraisainfo(data) { // 测试活动信息页面
    return request({
        url: '/backend/activity/test/info',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/setMiniprogramAddWechat
export function setMiniprogramAddWechat(data) { // 测试活动信息页面 小程序加微开关
    return request({
        url: '/backend/activity/test/setMiniprogramAddWechat',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/update
export function setappraisaupdate(data) { // 修改测试活动信息
    return request({
        url: '/backend/activity/test/update',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/updateOnline
export function setappraisaupdateOnline(data) { // 修改测试活动信息
    return request({
        url: '/backend/activity/test/updateOnline',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/delete
export function setappraisaupdatedelete(data) { // 删除测试活动信息
    return request({
        url: '/backend/activity/test/delete',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/getMiniprogramAddWechat
export function getMiniprogramAddWechat(data) { // 小程序加微状态
    return request({
        url: '/backend/activity/test/getMiniprogramAddWechat',
        method: 'post',
        data: data
    })
}
///backend/activity/test/createResult
export function createResult(data) { // 创建测试结果
    return request({
        url: '/backend/activity/test/createResult',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/saveTestQuestion
export function saveTestQuestion(data) { // 创建题目
    return request({
        url: '/backend/activity/test/saveTestQuestion',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/getTestQuestion
export function getTestQuestion(data) { // 获取题目
    return request({
        url: '/backend/activity/test/getTestQuestion',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/resultList
export function getresultList(data) { // 获取结果列表
    return request({
        url: '/backend/activity/test/resultList',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/updateResult
export function updateResult(data) { // 修改结果
    return request({
        url: '/backend/activity/test/updateResult',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/getTestDimensionList
export function getTestDimensionList(data) { // 修改结果
    return request({
        url: '/backend/activity/test/getTestDimensionList',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/updateShareImg
export function updateShareImg(data) { // 修改结果
    return request({
        url: '/backend/activity/test/updateShareImg',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/deleteTestResult
export function deleteTestResult(data) { // 修改结果
    return request({
        url: '/backend/activity/test/deleteTestResult',
        method: 'post',
        data: data
    })
}
//backend/activity/test/getPartakeRecord
export function getPartakeRecord(data) { // 参与记录
    return request({
        url: '/backend/activity/test/getPartakeRecord',
        method: 'post',
        data: data
    })
}
// /backend/activity/test/updateCommonCampIds
export function updateCommonCampIds(data) { // 修改批量
    return request({
        url: '/backend/activity/test/updateCommonCampIds',
        method: 'post',
        data: data
    })
}
///backend/activity/test/getCommonCampInfo
export function getCommonCampInfo(data) { // 获取批量
    return request({
        url: '/backend/activity/test/getCommonCampInfo',
        method: 'post',
        data: data
    })
}

//新优惠券列表接口
export function getCouponListNew(data) { // 修改结果
    return request({
        url: '/backend/coupon/getCouponListNew',
        method: 'post',
        data: data
    })
}
//新优惠券信息接口
export function couponInfoNew(data) {
    return request({
        url: '/backend/coupon/couponInfoNew',
        method: 'post',
        data: data
    })
}
//新优惠券保存接口
export function couponDataSaveNew(data) {
    return request({
        url: '/backend/coupon/couponDataSaveNew',
        method: 'post',
        data: data
    })
}

//新优惠券筛选商品接口
export function couponProductScreen(data) {
    return request({
        url: '/backend/coupon/couponProductScreen',
        method: 'post',
        data: data
    })
}


//新优惠券筛选课程接口
export function couponCourseScreen(data) {
    return request({
        url: '/backend/coupon/couponCourseScreen',
        method: 'post',
        data: data
    })
}

//新优惠券上下架接口
export function couponSet(data) {
    return request({
        url: '/backend/coupon/couponSet',
        method: 'post',
        data: data
    })
}

//新优惠券用户领取列表接口
export function couponUserGetData(data) {
    return request({
        url: '/backend/coupon/couponUserGetData',
        method: 'post',
        data: data
    })
}

//新优惠券领取列表设置使用接口
export function setIsUse(data) {
    return request({
        url: '/backend/coupon/setIsUse',
        method: 'post',
        data: data
    })
}

//新优惠券删除优惠券接口
export function deleteCoupon(data) {
    return request({
        url: '/backend/coupon/deleteCoupon',
        method: 'post',
        data: data
    })
}

//新优惠券指定课程列表接口
export function couponCourseData(data) {
    return request({
        url: '/backend/coupon/couponCourseData',
        method: 'post',
        data: data
    })
}
//新优惠券指定商品列表接口
export function couponProductData(data) {
    return request({
        url: '/backend/coupon/couponProductData',
        method: 'post',
        data: data
    })
}

//新优惠券审核接口
export function approveCoupon(data) {
    return request({
        url: '/backend/coupon/approveCoupon',
        method: 'post',
        data: data
    })
}
//新优惠券审核列表接口
export function approveList(data) {
    return request({
        url: '/backend/coupon/approveList',
        method: 'post',
        data: data
    })
}

// /backend/employee/performance/getPerformanceDepartmentList
export function getPerformanceDepartmentList(data) { // 获取不么列表
    return request({
        url: '/backend/employee/performance/getPerformanceDepartmentList',
        method: 'post',
        data: data
    })
}


//添加关联课程或商品
export function addRelationCourses(data) {
    return request({
        url: '/backend/coupon/addRelationCourses',
        method: 'post',
        data: data
    })
}

//删除关联课程或商品
export function delRelationCourse(data) {
    return request({
        url: '/backend/coupon/delRelationCourse',
        method: 'post',
        data: data
    })
}

//获取所选择的数据是否需要审核
export function getApproveStatus(data) {
    return request({
        url: '/backend/coupon/getApproveStatus',
        method: 'post',
        data: data
    })
}

//隐藏或显示测评活动
export function setIsHide(data) {
    return request({
        url: '/backend/activity/test/setIsHide',
        method: 'post',
        data: data
    })
}

//新优惠券指定可见人列表
export function getCanViewAccounts(data) {
    return request({
        url: '/backend/coupon/getCanViewAccounts',
        method: 'post',
        data: data
    })
}
//绩效账号设置绩效状态
export function setPerformanceStatus(data) {
    return request({
        url: '/backend/employee/performance/setPerformanceStatus',
        method: 'post',
        data: data
    })
}

//获取后台用户列表
export function getAccountList(data) {
    return request({
        url: '/backend/coupon/getAccountList',
        method: 'post',
        data: data
    })
}
//绩效账号设置修改时间节点
export function setPerformanceLastDay(data) {
    return request({
        url: '/backend/employee/performance/setPerformanceLastDay',
        method: 'post',
        data: data
    })
}

//提交可见人用户id
export function submitCanViewAccount(data) {
    return request({
        url: '/backend/coupon/submitCanViewAccount',
        method: 'post',
        data: data
    })
}
export function getPerformanceLastDay(data) {
    return request({
        url: '/backend/employee/performance/getPerformanceLastDay',
        method: 'post',
        data: data
    })
}

//删除某个可见人
export function delCanViewAccount(data) {
    return request({
        url: '/backend/coupon/delCanViewAccount',
        method: 'post',
        data: data
    })
}
export function getPerformanceConfig(data) {
    return request({
        url: '/backend/employee/performance/getPerformanceConfig',
        method: 'post',
        data: data
    })
}

//可见优惠券列表
export function getCanViewCouponList(data) {
    return request({
        url: '/backend/coupon/getCanViewCouponList',
        method: 'post',
        data: data
    })
}
export function setPerformanceConfig(data) {
    return request({
        url: '/backend/employee/performance/setPerformanceConfig',
        method: 'post',
        data: data
    })
}